module.exports = __webpack_public_path__ + "img/help-black-24-dp.ede1b972.svg";